// module.exports = { baseUrl: 'http://localhost:8080/', imageUrl: 'http://localhost/', projectName: '数学加CRM' }
module.exports = { baseUrl: 'http://crmadmin.shuxuejia.com/', imageUrl: 'http://crmadmin.shuxuejia.com/', projectName: '数学加CRM' }
// module.exports = { baseUrl: 'https://crmadmin.test.xuezone.com/', imageUrl: 'https://crmadmin.test.xuezone.com/', projectName: '数学加CRM' }
//http://crmadmin.test.xuezone.com/ 测试环境   http://crmadmin.shuxuejia.com/        /data/website/shuxuejiacrm



//////////////////
// WEBPACK FOOTER
// ./config/project/config-production.js
// module id = 9lxP
// module chunks = 60